import { Component, OnInit, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'user-internet-disconnected',
  templateUrl: './user-internet-disconnected.component.html',
  styleUrls: ['./user-internet-disconnected.component.scss'],
})
export class UserInternetDisconnectedComponent implements OnInit {
  @Input() error: any;
 
  constructor(private modalCtrl: PopoverController) { }

  ngOnInit() {}

  close() {
    this.modalCtrl.dismiss();
  }
}
